module.exports = __webpack_public_path__ + "img/fast.ced235b5.svg";